import * as React from 'react';

const CopyIcon: React.FC<React.SVGProps<SVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
    className={props.className}
  >
    <path
      className={props.className}
      stroke="currentColor"
      strokeLinecap="round"
      d="M5.75 10.25h-2.5a1.5 1.5 0 0 1-1.5-1.5v-5.5a1.5 1.5 0 0 1 1.5-1.5h5.5a1.5 1.5 0 0 1 1.5 1.5v2.5m-4.5 4.5v2.5a1.5 1.5 0 0 0 1.5 1.5h5.5a1.5 1.5 0 0 0 1.5-1.5v-5.5a1.5 1.5 0 0 0-1.5-1.5h-2.5m-4.5 4.5v-3a1.5 1.5 0 0 1 1.5-1.5h3M8 10h4m-2-2v4"
    ></path>
  </svg>
);

export default CopyIcon;
